import { createContext, useContext } from 'react';
import { OnboardingContextType } from './types';

export const OnboardingContext = createContext<OnboardingContextType>({} as OnboardingContextType);
export const useOnboarding = () => useContext(OnboardingContext);